import { format, addDays } from 'date-fns';

const DEVELOPMENT_DATE = new Date('2026-02-05');
const DATE_TODAY = format(DEVELOPMENT_DATE, 'yyyy-MM-dd');
const DATE_TOMORROW = format(addDays(DEVELOPMENT_DATE, 1), 'yyyy-MM-dd');

const mockUser = {
    id: 'mock-user-id',
    email: 'mock@example.com',
    app_metadata: {},
    user_metadata: {},
    aud: 'authenticated',
    created_at: new Date().toISOString()
};

const mockBrands = [
    { id: 90, name: 'EL&N Brand' },
    { id: 100, name: 'Other Brand' }
];

const mockShops = [
    { id: 1, name: 'Shop 1', brand_id: 90, brands: mockBrands[0], active: true, show_in_delivery_table: true, orders: [], products: [] },
    { id: 2, name: 'Shop 2', brand_id: 90, brands: mockBrands[0], active: true, show_in_delivery_table: true, orders: [], products: [] },
    { id: 3, name: 'Shop 3', brand_id: 100, brands: mockBrands[1], active: true, show_in_delivery_table: true, orders: [], products: [] }
];

const mockDBUser = {
    id: 1,
    uuid: 'mock-user-id',
    email: 'mock@example.com',
    firstname: 'Mock',
    lastname: 'Admin',
    active: true,
    admin: true,
    superadmin: true,
    p_admin: 2,
    p_orders: 2,
    p_speccards: 2,
    shops: mockShops
};

const mockCategories = [
    { id: 1, name: 'Cakes', position: 1 },
    { id: 2, name: 'Pastries', position: 2 },
    { id: 3, name: 'Drinks', position: 3 }
];

const mockSuppliers = [
    { id: 1, name: 'Main Bakery' },
    { id: 2, name: 'External Supplier' }
];

const mockProducts = [
    { id: 1, name: 'Chocolate Cake', pid: 10001, category_id: 1, supplier_id: 1, categories: mockCategories[0], suppliers: mockSuppliers[0], shopProducts: [{ shop_id: 1, unit_cost: 1500 }], active: true },
    { id: 2, name: 'Croissant', pid: 20001, category_id: 2, supplier_id: 1, categories: mockCategories[1], suppliers: mockSuppliers[0], shopProducts: [{ shop_id: 1, unit_cost: 200 }], active: true },
    { id: 3, name: 'Orange Juice', pid: 30001, category_id: 3, supplier_id: 2, categories: mockCategories[2], suppliers: mockSuppliers[1], shopProducts: [{ shop_id: 1, unit_cost: 300 }], active: true },
    { id: 4, name: 'Strawberry Cake', pid: 40001, category_id: 1, supplier_id: 1, categories: mockCategories[0], suppliers: mockSuppliers[0], shopProducts: [{ shop_id: 1, unit_cost: 1600 }], active: true }
];

// Orders for Today
const mockOrders = [
    {
        id: 1001,
        shop_id: 1,
        shops: mockShops[0],
        delivery_dt: DATE_TODAY,
        status: 'pending',
        order_type: 0, // Normal order
        purchase_order_num: 'PO-123',
        voided: false,
        imported_at: new Date().toISOString(),
        notes: 'Deliver early',
        orderProducts: [
            { id: 1, order_id: 1001, product_id: 1, quantity: 2, unit_cost: 1500, products: mockProducts[0] },
            { id: 2, order_id: 1001, product_id: 2, quantity: 10, unit_cost: 200, products: mockProducts[1] }
        ],
        orderCustoms: []
    },
    {
        id: 1002,
        shop_id: 2,
        shops: mockShops[1],
        delivery_dt: DATE_TODAY,
        status: 'approved',
        order_type: 0,
        purchase_order_num: 'PO-456',
        voided: false,
        imported_at: new Date().toISOString(),
        orderProducts: [
            { id: 3, order_id: 1002, product_id: 1, quantity: 1, unit_cost: 1500, products: mockProducts[0] },
            { id: 4, order_id: 1002, product_id: 3, quantity: 5, unit_cost: 300, products: mockProducts[2] }
        ],
        orderCustoms: []
    },
    {
        id: 1003,
        shop_id: 3,
        shops: mockShops[2],
        delivery_dt: DATE_TODAY,
        status: 'pending',
        order_type: 1, // Custom order
        purchase_order_num: 'PO-CUSTOM',
        voided: false,
        imported_at: new Date().toISOString(),
        orderProducts: [],
        orderCustoms: [
            { id: 1, order_id: 1003, sponge: 'Vanilla', filling: 'Cream', fruit: 'Strawberry', topping: 'Choco', size: '10 inch', shape: 'Round', message: 'Happy Birthday', notes: '', unit_cost: 5000 }
        ]
    }
];

// Orders for Tomorrow
const mockOrdersFeb04 = [
    {
        id: 2001,
        shop_id: 1,
        shops: mockShops[0],
        delivery_dt: DATE_TOMORROW,
        status: 'pending',
        order_type: 0,
        purchase_order_num: 'PO-FEB04-1',
        voided: false,
        imported_at: new Date().toISOString(),
        notes: 'Feb 4th Order',
        orderProducts: [
            { id: 10, order_id: 2001, product_id: 1, quantity: 5, unit_cost: 1500, products: mockProducts[0] }
        ],
        orderCustoms: []
    }
];

const mockRecipes = [
    {
        id: 1,
        pid: 10001,
        name: 'Chocolate Sponge',
        display_name: 'Classic Chocolate Sponge',
        type: 'PRODUCT',
        active: true,
        quantity: 1,
        quantity_unit: 'kg',
        allergens: 'Gluten, Eggs, Milk',
        imported_at: DATE_TODAY,
        steps: [
            { id: 1, recipe_id: 1, txt: '1|Mix dry ingredients', position: 1 },
            { id: 2, recipe_id: 1, txt: '2|Add wet ingredients', position: 2 }
        ],
        ingredients: []
    },
    {
        id: 2,
        pid: 20001,
        name: 'Chocolate Cake',
        display_name: 'Indulgent Chocolate Cake',
        type: 'DISH',
        active: true,
        quantity: 1,
        quantity_unit: 'dish',
        allergens: 'Gluten, Eggs, Milk, Soya',
        imported_at: DATE_TODAY,
        steps: [
            { id: 3, recipe_id: 2, txt: '1|Bake the sponge', position: 1 },
            { id: 4, recipe_id: 2, txt: 'Indulgent frosting', position: 2 }
        ],
        ingredients: [
            { id: 1, parent_pid: 20001, child_pid: 10001, quantity: 0.5, quantity_unit: 'kg', position: 1 }
        ]
    }
];

const allMockOrders = [...mockOrders, ...mockOrdersFeb04];

let authListener = null;

class MockQueryBuilder {
    constructor(table, type = 'select', mutationData = null) {
        this.table = table;
        this.type = type;
        this.data = [];
        this.isSingle = false;
        this.mutationData = mutationData;
        this.error = null;

        // Default mock data configuration
        if (table === 'users') this.data = [mockDBUser];
        if (table === 'shops') this.data = mockShops;
        if (table === 'categories') this.data = mockCategories;
        if (table === 'suppliers') this.data = mockSuppliers;
        if (table === 'brands') this.data = mockBrands;
        if (table === 'products') this.data = mockProducts;

        if (table === 'orders') this.data = allMockOrders;
        if (table === 'recipes') this.data = mockRecipes;
    }

    // Filters
    eq(col, val) {
        if (col.includes('.') && !this.data.some(item => item.hasOwnProperty(col))) return this;
        this.data = this.data.filter(item => item[col] === val);
        return this;
    }
    neq(col, val) {
        if (col.includes('.') && !this.data.some(item => item.hasOwnProperty(col))) return this;
        this.data = this.data.filter(item => item[col] !== val);
        return this;
    }
    gt(col, val) { return this; }
    gte(col, val) {
        if (col.includes('.') && !this.data.some(item => item.hasOwnProperty(col))) return this;
        this.data = this.data.filter(item => item[col] >= val);
        return this;
    }
    lt(col, val) { return this; }
    lte(col, val) {
        if (col.includes('.') && !this.data.some(item => item.hasOwnProperty(col))) return this;
        this.data = this.data.filter(item => item[col] <= val);
        return this;
    }
    like(col, val) { return this; }
    ilike(col, val) { return this; }
    is(col, val) { return this; }
    in(col, val) { return this; }
    contains(col, val) { return this; }
    containedBy(col, val) { return this; }
    rangeGt(col, val) { return this; }
    rangeGte(col, val) { return this; }
    rangeLt(col, val) { return this; }
    rangeLte(col, val) { return this; }
    rangeAdjacent(col, val) { return this; }
    overlaps(col, val) { return this; }
    textSearch(col, val) { return this; }

    match(criteria) {
        this.data = this.data.filter(item => {
            return Object.keys(criteria).every(key => item[key] === criteria[key]);
        });
        return this;
    }
    not(col, op, val) { return this; }
    or(val) {
        const conditions = val.split(',');
        this.data = this.data.filter(item => {
            return conditions.some(cond => {
                // Handle "id.eq.123"
                if (cond.includes('.eq.')) {
                    const parts = cond.split('.eq.');
                    const col = parts[0];
                    const val = parts[1];
                    // Loose equality for numbers vs strings
                    return item[col] === val;
                }
                // Handle "notes.ilike.%term%"
                if (cond.includes('.ilike.')) {
                    const parts = cond.split('.ilike.');
                    const col = parts[0];
                    const val = parts[1];
                    const cleanVal = val.replace(/%/g, '').toLowerCase();
                    const itemVal = (item[col] || '').toString().toLowerCase();
                    return itemVal.includes(cleanVal);
                }
                return false;
            });
        });
        return this;
    }
    filter(col, op, val) { return this; }

    // Modifiers
    order(col, { ascending = true } = {}) {
        this.data.sort((a, b) => {
            if (a[col] > b[col]) return ascending ? 1 : -1;
            if (a[col] < b[col]) return ascending ? -1 : 1;
            return 0;
        });
        return this;
    }
    limit(count) {
        this.data = this.data.slice(0, count);
        return this;
    }
    range(from, to) {
        this.data = this.data.slice(from, to + 1);
        return this;
    }
    offset(count) { return this; }
    single() { this.isSingle = true; return this; }
    maybeSingle() { this.isSingle = true; return this; }

    // Transform
    select(cols) { return this; }

    // Execution
    async then(resolve, reject) {
        // Return a deep copy to prevent mutation issues (e.g. "object is not extensible" in React Strict Mode)
        let sourceData = this.data;
        if (['insert', 'update', 'upsert'].includes(this.type) && this.mutationData) {
            sourceData = Array.isArray(this.mutationData) ? this.mutationData : [this.mutationData];
        }

        const dataCopy = JSON.parse(JSON.stringify(sourceData));
        const result = { data: this.isSingle ? (dataCopy.length ? dataCopy[0] : null) : dataCopy, error: this.error };

        if (this.table === 'users' && (this.type === 'update' || this.type === 'insert')) {
            result.data = JSON.parse(JSON.stringify(mockDBUser));
        }

        if (resolve) resolve(result);
        return result;
    }
}

export const mockSupabase = {
    auth: {
        signInWithPassword: async ({ email, password }) => {
            if (authListener) authListener('SIGNED_IN', { user: mockUser });
            return { data: { user: mockUser, session: { user: mockUser } }, error: null };
        },
        signOut: async () => {
            if (authListener) authListener('SIGNED_OUT', null);
            return { error: null };
        },
        onAuthStateChange: (callback) => {
            authListener = callback;
            return { data: { subscription: { unsubscribe: () => { } } } };
        },
        getSession: async () => {
            const stored = localStorage.getItem('mock-session');
            if (stored) {
                return { data: { session: { user: mockUser } } };
            }
            return { data: { session: null } };
        }
    },
    from: (table) => {
        return {
            select: (columns) => new MockQueryBuilder(table, 'select'),
            insert: (data) => new MockQueryBuilder(table, 'insert', data),
            update: (data) => new MockQueryBuilder(table, 'update', data),
            delete: () => new MockQueryBuilder(table, 'delete'),
            upsert: (data) => new MockQueryBuilder(table, 'upsert', data),
        };
    }
};

const originalSignIn = mockSupabase.auth.signInWithPassword;
mockSupabase.auth.signInWithPassword = async (creds) => {
    localStorage.setItem('mock-session', 'true');
    return originalSignIn(creds);
}
const originalSignOut = mockSupabase.auth.signOut;
mockSupabase.auth.signOut = async () => {
    localStorage.removeItem('mock-session');
    return originalSignOut();
}
